<template>
  <div>
    <b-anonymous-event-details
      :startCollapsibleOpen="true"
      :id="$route.params.id"
      :module="module"
      :path-on-register="pathOnRegister"/>
    <br>
    <b-floating-back-button/>
  </div>
</template>

<script>
export default {
  name: "Details",
  data() {
    return {
      pathOnRegister: window.bomconfig.pathOnRegister,
      module: window.bomconfig.module,
    };
  },
};
</script>

<style scoped>

</style>
